import styled from '@themes/theme'

export const TelegramContainer = styled.div`
  padding: 16px 18px 14px 18px;
  .input {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 46px;
    padding: 6px 6px 6px 18px;
    margin-bottom: 15px;
    border-radius: 100px;
    background: ${props => props.theme.color.modalBg};
    &--text {
      width: 100%;
      border: none;
      font-weight: ${props => props.theme.fontW.bold};
      font-size: ${props => props.theme.font.large};
      color: ${props => props.theme.color.modalSubTxt};
      text-align: left;
      background-color: transparent;
      &::placeholder {
        color: ${props => props.theme.color.modalDarkBg};
      }
    }
    &--btn {
      width: 80px;
      height: 100%;
      flex-shrink: 0;
      margin-left: 5px;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.themeTxt};
    }
  }
  .alert {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 4px;
    &--item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 10px 0;
      &:not(:first-child) {
        padding-top: 19px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 2px * 2);
          height: 1px;
          margin: 4px 0;
          background-color: ${props => props.theme.color.modalBg};
        }
      }
      &--label {
        margin-left: 6px;
        color: ${props => props.theme.color.modalTxt};
        font-weight: ${props => props.theme.fontW.medium};
        font-size: ${props => props.theme.font.large};
      }
      &--switch {
        position: absolute;
        left: 0;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        border: 0;
        clip: rect(0, 0, 0, 0);
        & + .on-off-wrap {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 80px;
          height: 34px;
          padding: 5px 10px;
          border-radius: 50px;
          background: ${props => props.theme.color.modalSubBg};
          transition: all .3s;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 5px;
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: ${props => props.theme.color.themeTxt};
            transform: translate(0, -50%);
            transition: all .3s;
          }
          .on, .off {
            position: relative;
            font-size: ${props => props.theme.font.large};
            color: ${props => props.theme.color.white};
          }
          .on {
            display: none;
          }
          .off {
            display: block;
          }
        }

        &:checked + .on-off-wrap {
          justify-content: flex-start;
          background: ${props => props.theme.color.primaryBg};
          .on {
            display: block;
          }
          .off {
            display: none;
          }
          &::after {
            transform: translate(190%, -50%);
          }
        }
      }
    }
  }
`
